const firebaseConfig = {
  apiKey: "AIzaSyD__rxPgr4aDkNBQfN8-6U7UtvZLIjz6zk",
  authDomain: "star-healthcare-bd.firebaseapp.com",
  projectId: "star-healthcare-bd",
  storageBucket: "star-healthcare-bd.appspot.com",
  messagingSenderId: "544158575229",
  appId: "1:544158575229:web:f9e5208b874d1c23bf9f14",
};
export default firebaseConfig;
